module.exports = __webpack_public_path__ + "static/team-6edc9a40960222e0d7cc1eafa1ed1054.jpg";